export enum JoinTypeEnum {
    none,
    and,
    or,
    bracket
}